import glamorous from "glamorous"
import style from "utils/style"

const Quote = glamorous.div({
  borderLeft: `5px solid ${style.colors.darkGrayOrange}`,
  color: style.colors.brown,
  fontStyle: "italic",
  fontWeight: 100,
  fontSize: "1.7rem",
  padding: 10,
  paddingLeft: 20,
  lineHeight: 1.4,
  letterSpacing: -0.9,
  margin: 20,
})

export default Quote



// WEBPACK FOOTER //
// ./src/elements/Quote.js